import React from 'react';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { setFilters, fetchProjects } from '../../store/slices/projectsSlice';
import Input from '../UI/Input';
import Select from '../UI/Select';

const ProjectFilters: React.FC = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.projects.list);

  const handleFilterChange = (key: string, value: string) => {
    dispatch(setFilters({ [key]: value }));
    dispatch(fetchProjects({ ...filters, [key]: value }));
  };

  const categories = [
    { value: '', label: 'All Categories' },
    { value: 'infrastructure', label: 'Infrastructure' },
    { value: 'environment', label: 'Environment' },
    { value: 'education', label: 'Education' },
    { value: 'health', label: 'Health' },
    { value: 'culture', label: 'Culture' },
    { value: 'other', label: 'Other' },
  ];

  const statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'draft', label: 'Draft' },
    { value: 'planned', label: 'Planned' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'active', label: 'Active' },
    { value: 'vote_session', label: 'Vote Session' },
    { value: 'executed', label: 'Executed' },
  ];

  const parishes = [
    { value: '', label: 'All Parishes' },
    { value: "St. John's", label: "St. John's" },
    { value: 'St. George', label: 'St. George' },
    { value: 'St. Peter', label: 'St. Peter' },
    { value: 'St. Paul', label: 'St. Paul' },
    { value: 'St. Mary', label: 'St. Mary' },
    { value: 'St. Philip', label: 'St. Philip' },
    { value: 'Barbuda', label: 'Barbuda' },
  ];

  const sortOptions = [
    { value: 'date', label: 'Date' },
    { value: 'activity', label: 'Activity' },
    { value: 'votes', label: 'Votes' },
  ];

  return (
    <div className="bg-[var(--color-default-background)] p-4 rounded-lg shadow-sm mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <Input
          label="Search"
          placeholder="Search projects..."
          value={filters.search}
          onChange={(e) => handleFilterChange('search', e.target.value)}
          fullWidth
        />
        <Select
          label="Category"
          options={categories}
          value={filters.category}
          onChange={(e) => handleFilterChange('category', e.target.value)}
          fullWidth
        />
        <Select
          label="Status"
          options={statuses}
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          fullWidth
        />
        <Select
          label="Parish"
          options={parishes}
          value={filters.parish}
          onChange={(e) => handleFilterChange('parish', e.target.value)}
          fullWidth
        />
        <Select
          label="Sort By"
          options={sortOptions}
          value={filters.sortBy}
          onChange={(e) => handleFilterChange('sortBy', e.target.value)}
          fullWidth
        />
      </div>
    </div>
  );
};

export default ProjectFilters;

